var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { SrciScreenEnumsObj } from "../enums/internal/SrciScreenEnum";
import { SrciEventTypeEnumsObj } from "../enums/SrciEventTypeEnum";
import { DcfSdkEnumsObj } from "../enums/DcfSdkEnum";
import EventReporter from "./eventReporter/EventReporter";
import { validateSrciButtonParams } from "../models/SrciButtonParams";
import { validateSrciInitParams } from "../helpers/SrciValidation";
import srciLogicSdk from "@payair/srci-logic-sdk";
import { defaultPaymentSheetContainerId, srciUiComponentId, SrciUiSdk } from "./ui/SrciUi";
import { SrciLogic } from "./SrciLogic";
import { SrciDcfFrame } from "./SrciDcfFrame";
import { BUILD_TYPE, SDK_VERSION } from "../models/SrciVersion";
import { BaseEcomSdkEnumsObj } from "@payair/e-com-common-sdk/models/BaseEcomSdkEnum";
import { getValuesFromLocale } from "@payair/e-com-common-sdk/core/Helpers";
import LanguageHandler from "../helpers/language/LanguageHandler";
import { MerchantRecognitionCoordinator } from "./recognition/MerchantRecognitionCoordinator";
import { lockPaymentSheetHostScroll, unlockPaymentSheetHostScroll } from "./PaymentSheetHostScrollLock";
import { ensurePaymentSheetStyles, paymentSheetOverlayClassName, paymentSheetScreenClassName, } from "./PaymentSheetStyles";
import { buildReasonTelemetry, buildUnexpectedExceptionTelemetry } from "./telemetry/SrciTelemetry";
/** @internal */
var commonState = {
    initParams: undefined,
    paymentSheetContainerId: undefined,
    isConsumerPresent: false,
    defaultDcfSdk: undefined,
    isCloseButtonEnabled: true,
    isDcfFlowPopUp: false,
    identityValidationChannels: undefined,
    otpChannelsData: undefined,
    selectedOtpChannel: undefined,
    pendingOtpSendOperation: undefined,
    rememberMeConsent: false,
    profileErrors: undefined,
    addCardForNoCardsCase: false,
};
/** @internal */
var mastercardState = {
    isSupported: false,
    idTokens: undefined,
    getProfileResponse: undefined,
};
/** @internal */
var visaState = {
    isSupported: false,
    idTokens: undefined,
    getProfileResponse: undefined,
};
/** @internal */ var eventReporter = new EventReporter();
/** @internal */ var srciDcfFrame = new SrciDcfFrame();
/** @internal */ var languageHandler;
/** @internal */ var srciUiSdk;
/** @internal */ var srciLogic;
/** @internal */ var locale = null;
/** @internal */
var SrciSdkImpl = /** @class */ (function () {
    function SrciSdkImpl() {
        this.initSdk = function (srciInitParams) {
            initSrciImpl(srciInitParams);
        };
        this.renderButton = function (container, srciButtonParams) {
            return renderButtonImpl(container, srciButtonParams);
        };
        this.isReadyToPay = function () { return isReadyToPayImpl(); };
        this.startPayment = function (container) {
            startPaymentImpl(container);
        };
        this.isUserEligibleToMakePayment = function () { return isUserEligibleToMakePaymentImpl(); };
        this.getVersion = function () {
            return {
                sdk: BaseEcomSdkEnumsObj.PAYAIR_SRCI_SDK,
                version: SDK_VERSION,
                buildType: BUILD_TYPE,
            };
        };
    }
    return SrciSdkImpl;
}());
export { SrciSdkImpl };
/** @internal */
export var initSrciImpl = function (srciInitParams, successEvent) {
    if (successEvent === void 0) { successEvent = SrciEventTypeEnumsObj.SDK_INITIALIZE_SUCCESS; }
    return __awaiter(void 0, void 0, void 0, function () {
        var srciInitParamsValidationResult, localeData, mcParams, visaParams, merchantRecognition, mcInitResult, visaInitResult, isReadyToPayResult, srciUiParams, supportedNetworks, isRecognizedResponse, mastercardProfilesFound, visaProfilesFound, error_1;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        return __generator(this, function (_l) {
            switch (_l.label) {
                case 0:
                    eventReporter.reset();
                    commonState.pendingOtpSendOperation = undefined;
                    srciInitParamsValidationResult = validateSrciInitParams(srciInitParams);
                    if (srciInitParamsValidationResult && srciInitParamsValidationResult.length > 0) {
                        eventReporter.sendEvent(SrciEventTypeEnumsObj.SDK_PARAMETERS_FAILED_VALIDATION, buildReasonTelemetry("INVALID_PARAMETERS", {}, srciInitParamsValidationResult.join(", ")));
                        return [2 /*return*/];
                    }
                    localeData = getValuesFromLocale(srciInitParams.locale);
                    if (!localeData) {
                        eventReporter.sendEvent(SrciEventTypeEnumsObj.SDK_PARAMETERS_FAILED_VALIDATION, buildReasonTelemetry("INVALID_LOCALE", {}, "'locale' param is not valid"));
                        return [2 /*return*/];
                    }
                    locale = srciInitParams.locale;
                    commonState.rememberMeConsent = false;
                    _l.label = 1;
                case 1:
                    _l.trys.push([1, 12, , 13]);
                    mcParams = srciInitParams.merchantId.get(DcfSdkEnumsObj.MASTERCARD);
                    visaParams = srciInitParams.merchantId.get(DcfSdkEnumsObj.VISA);
                    eventReporter.initEventReporterService(srciInitParams.pspName, srciInitParams.transactionId, (mcParams === null || mcParams === void 0 ? void 0 : mcParams.srciIdentificator.srciDpaId) ? mcParams.srciIdentificator.srciDpaId : "", (visaParams === null || visaParams === void 0 ? void 0 : visaParams.srciIdentificator.srciDpaId) ? visaParams.srciIdentificator.srciDpaId : "");
                    eventReporter.sendEvent(successEvent === SrciEventTypeEnumsObj.SDK_REINITIALIZED
                        ? SrciEventTypeEnumsObj.SDK_REINITIALIZE_STARTED
                        : SrciEventTypeEnumsObj.SDK_INITIALIZE_STARTED);
                    languageHandler = new LanguageHandler(localeData.lang);
                    merchantRecognition = new MerchantRecognitionCoordinator(eventReporter);
                    srciLogic = new SrciLogic(srciDcfFrame, languageHandler, eventReporter, srciInitParams.allowedCardCountries, srciInitParams.allowedCardTypes, merchantRecognition);
                    srciUiSdk = new SrciUiSdk(srciLogic, languageHandler, eventReporter);
                    mastercardState.isSupported = !!mcParams;
                    visaState.isSupported = !!visaParams;
                    if (!mcParams) return [3 /*break*/, 3];
                    return [4 /*yield*/, srciLogic.init(srciInitParams, mcParams, DcfSdkEnumsObj.MASTERCARD)];
                case 2:
                    mcInitResult = _l.sent();
                    if (!mcInitResult) {
                        throw new Error("Mastercard initialize failed.");
                    }
                    _l.label = 3;
                case 3:
                    if (!visaParams) return [3 /*break*/, 5];
                    return [4 /*yield*/, srciLogic.init(srciInitParams, visaParams, DcfSdkEnumsObj.VISA)];
                case 4:
                    visaInitResult = _l.sent();
                    if (!visaInitResult) {
                        throw new Error("Visa initialize failed.");
                    }
                    _l.label = 5;
                case 5: return [4 /*yield*/, isReadyToPayImpl()];
                case 6:
                    isReadyToPayResult = _l.sent();
                    if (!isReadyToPayResult) {
                        eventReporter.sendEvent(SrciEventTypeEnumsObj.SDK_INITIALIZE_FAIL_DEVICE_NOT_ELIGIBLE);
                        return [2 /*return*/];
                    }
                    commonState.initParams = undefined;
                    srciUiParams = srciInitParams.srciUiParams;
                    if (srciUiParams) {
                        commonState.isCloseButtonEnabled =
                            typeof srciUiParams.isCloseButtonEnabled === "boolean" ? srciUiParams.isCloseButtonEnabled : true;
                        commonState.isDcfFlowPopUp =
                            typeof srciUiParams.isDcfFlowPopUp === "boolean" ? srciUiParams.isDcfFlowPopUp : false;
                    }
                    supportedNetworks = [];
                    if (mastercardState.isSupported)
                        supportedNetworks.push(DcfSdkEnumsObj.MASTERCARD);
                    if (visaState.isSupported)
                        supportedNetworks.push(DcfSdkEnumsObj.VISA);
                    return [4 /*yield*/, merchantRecognition.recognizeConsumer(supportedNetworks)];
                case 7:
                    isRecognizedResponse = _l.sent();
                    mastercardState.idTokens = (_b = (_a = isRecognizedResponse.find(function (item) { return item.sdk === DcfSdkEnumsObj.MASTERCARD; })) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.idTokens;
                    visaState.idTokens = (_d = (_c = isRecognizedResponse.find(function (item) { return item.sdk === DcfSdkEnumsObj.VISA; })) === null || _c === void 0 ? void 0 : _c.value) === null || _d === void 0 ? void 0 : _d.idTokens;
                    return [4 /*yield*/, srciLogic.getProfilesAndUpdateState(commonState, mastercardState, visaState)];
                case 8:
                    _l.sent();
                    mastercardProfilesFound = (((_f = (_e = mastercardState.getProfileResponse) === null || _e === void 0 ? void 0 : _e.profiles) === null || _f === void 0 ? void 0 : _f.length) ? mastercardState.getProfileResponse.profiles.length : 0) >
                        0;
                    visaProfilesFound = (((_h = (_g = visaState.getProfileResponse) === null || _g === void 0 ? void 0 : _g.profiles) === null || _h === void 0 ? void 0 : _h.length) ? visaState.getProfileResponse.profiles.length : 0) > 0;
                    if (!(((_j = srciInitParams.srciConsumer) === null || _j === void 0 ? void 0 : _j.emailAddress) && !mastercardProfilesFound && !visaProfilesFound)) return [3 /*break*/, 10];
                    return [4 /*yield*/, srciLogic.callIdentityLookup(commonState, (_k = srciInitParams.srciConsumer) === null || _k === void 0 ? void 0 : _k.emailAddress)];
                case 9:
                    _l.sent();
                    return [3 /*break*/, 11];
                case 10:
                    commonState.isConsumerPresent = false;
                    _l.label = 11;
                case 11:
                    commonState.initParams = srciInitParams;
                    eventReporter.sendEvent(successEvent);
                    return [3 /*break*/, 13];
                case 12:
                    error_1 = _l.sent();
                    commonState.initParams = undefined;
                    eventReporter.sendEvent(SrciEventTypeEnumsObj.SDK_INITIALIZE_ERROR, buildUnexpectedExceptionTelemetry({}, error_1));
                    return [3 /*break*/, 13];
                case 13: return [2 /*return*/];
            }
        });
    });
};
/** @internal */
export var getInitScreen = function (canShowOTPScreen) {
    var _a, _b;
    commonState.addCardForNoCardsCase = false;
    var mastercardProfiles = (_a = mastercardState.getProfileResponse) === null || _a === void 0 ? void 0 : _a.profiles;
    var visaProfiles = (_b = visaState.getProfileResponse) === null || _b === void 0 ? void 0 : _b.profiles;
    var isMastercardProfiles = mastercardProfiles ? mastercardProfiles.length > 0 : false;
    var isVisaProfiles = visaProfiles ? visaProfiles.length > 0 : false;
    var isMastercardCardListEmpty = mastercardProfiles === null || mastercardProfiles === void 0 ? void 0 : mastercardProfiles.filter(function (profile) { return profile.maskedCards.length; }).length;
    var isVisaCardListEmpty = visaProfiles === null || visaProfiles === void 0 ? void 0 : visaProfiles.filter(function (profile) { return profile.maskedCards.length; }).length;
    var haveVisaProfileWithoutCards = isVisaProfiles && !isVisaCardListEmpty;
    var haveMastercardProfileWithoutCards = isMastercardProfiles && !isMastercardCardListEmpty;
    var haveOnlyMastercardProfileWithCards = isMastercardProfiles && !isMastercardCardListEmpty && !isVisaProfiles;
    var haveOnlyVisaProfileWithCards = isVisaProfiles && !isVisaCardListEmpty && !isMastercardProfiles;
    if ((haveVisaProfileWithoutCards && haveMastercardProfileWithoutCards) ||
        haveOnlyMastercardProfileWithCards ||
        haveOnlyVisaProfileWithCards) {
        commonState.addCardForNoCardsCase = true;
        return SrciScreenEnumsObj.ADD_CARD_SCREEN;
    }
    else if (isMastercardProfiles || isVisaProfiles) {
        return SrciScreenEnumsObj.CARD_LIST_SCREEN;
    }
    else if (commonState.isConsumerPresent && canShowOTPScreen)
        return SrciScreenEnumsObj.OTP_SCREEN;
    return SrciScreenEnumsObj.NEW_USER_SCREEN;
};
var renderButtonImpl = function (container, srciButtonParams) {
    var _a;
    var validationResult = validateSrciButtonParams(srciButtonParams);
    if (validationResult.length > 0) {
        eventReporter.sendEvent(SrciEventTypeEnumsObj.BUTTON_RENDER_FAIL_BUTTON_PARAMS_VALIDATION_ERROR, buildReasonTelemetry("INVALID_PARAMETERS", {}, validationResult.join(", ")));
        return;
    }
    var buttonContainer = document.getElementById(container);
    if (!buttonContainer) {
        eventReporter.sendEvent(SrciEventTypeEnumsObj.BUTTON_RENDER_FAIL_BUTTON_CONTAINER_DOESNT_EXISTS);
        return;
    }
    var existingButton = document.querySelector("srci-button");
    if (!existingButton) {
        var srciButton = srciUiSdk === null || srciUiSdk === void 0 ? void 0 : srciUiSdk.getSrciButton(srciButtonParams, locale, mastercardState, visaState, startPaymentImpl);
        if (!srciButton) {
            eventReporter.sendEvent(SrciEventTypeEnumsObj.BUTTON_RENDER_FAIL_BUTTON_SDK_NOT_INITIALIZED_PROPERLY);
            return;
        }
        (_a = document.getElementById(container)) === null || _a === void 0 ? void 0 : _a.append(srciButton);
        eventReporter.sendEvent(SrciEventTypeEnumsObj.BUTTON_RENDERED);
        return;
    }
    eventReporter.sendEvent(SrciEventTypeEnumsObj.BUTTON_NOT_RENDERED_ALREADY_EXISTS);
};
/** @internal */
export var isReadyToPayImpl = function () {
    if (!srciLogicSdk.isBrowserSupported()) {
        eventReporter.sendEvent(SrciEventTypeEnumsObj.DEVICE_NOT_READY_TO_PAY, buildReasonTelemetry("BROWSER_NOT_SUPPORTED"));
        return Promise.resolve(false);
    }
    eventReporter.sendEvent(SrciEventTypeEnumsObj.DEVICE_READY_TO_PAY);
    return Promise.resolve(true);
};
var startPaymentImpl = function (container) { return __awaiter(void 0, void 0, void 0, function () {
    var defaultPaymentSheetContainer, paymentSheetContainer_1, paymentSheetContainer, screenUpdate, initScreen, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (container && typeof container !== "string") {
                    eventReporter.sendEvent(SrciEventTypeEnumsObj.PAYMENT_SHEET_RENDER_FAIL_PARAMS_VALIDATION_ERROR, buildReasonTelemetry("INVALID_CONTAINER", {}, "'container' param must string"));
                    return [2 /*return*/];
                }
                defaultPaymentSheetContainer = document.getElementById(defaultPaymentSheetContainerId);
                if (defaultPaymentSheetContainer) {
                    eventReporter.sendEvent(SrciEventTypeEnumsObj.PAYMENT_SHEET_RENDER_FAIL_ALREADY_EXISTS);
                    return [2 /*return*/];
                }
                if (!container) {
                    container = defaultPaymentSheetContainerId;
                    paymentSheetContainer_1 = document.getElementById(container);
                    if (paymentSheetContainer_1) {
                        eventReporter.sendEvent(SrciEventTypeEnumsObj.PAYMENT_SHEET_RENDER_FAIL_ALREADY_EXISTS);
                        return [2 /*return*/];
                    }
                    addContainerToBody(container);
                }
                commonState.paymentSheetContainerId = container;
                paymentSheetContainer = document.getElementById(container);
                if (!paymentSheetContainer) {
                    eventReporter.sendEvent(SrciEventTypeEnumsObj.PAYMENT_SHEET_RENDER_FAIL_CONTAINER_DOESNT_EXISTS);
                    return [2 /*return*/];
                }
                if (paymentSheetContainer.hasChildNodes()) {
                    eventReporter.sendEvent(SrciEventTypeEnumsObj.PAYMENT_SHEET_RENDER_FAIL_ALREADY_EXISTS);
                    return [2 /*return*/];
                }
                window.addEventListener("resize", srciDcfFrame.onResizeEvent);
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 5]);
                initScreen = getInitScreen(true);
                screenUpdate = updateScreen(initScreen);
                srciDcfFrame.createDcfIframe(paymentSheetContainer, commonState.isDcfFlowPopUp);
                return [4 /*yield*/, screenUpdate];
            case 2:
                _a.sent();
                eventReporter.sendEvent(SrciEventTypeEnumsObj.PAYMENT_SHEET_RENDERED);
                return [3 /*break*/, 5];
            case 3:
                error_2 = _a.sent();
                return [4 /*yield*/, (screenUpdate === null || screenUpdate === void 0 ? void 0 : screenUpdate.catch(function () { return undefined; }))];
            case 4:
                _a.sent();
                window.removeEventListener("resize", srciDcfFrame.onResizeEvent);
                paymentSheetContainer.replaceChildren();
                if (container === defaultPaymentSheetContainerId) {
                    paymentSheetContainer.remove();
                    unlockPaymentSheetHostScroll();
                }
                commonState.paymentSheetContainerId = undefined;
                throw error_2;
            case 5: return [2 /*return*/];
        }
    });
}); };
var isUserEligibleToMakePaymentImpl = function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, isReadyToPayImpl()];
        case 1: return [2 /*return*/, (_a.sent()) && Promise.resolve(commonState.initParams !== undefined)
            /** @internal */
        ];
    }
}); }); };
/** @internal */
export var updateScreen = function (newSrciScreen, isFetchProfilesEnabled) { return __awaiter(void 0, void 0, void 0, function () {
    var paymentSheetContainer, isCloseButtonEnabled, screenElement, srciUiComponent;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                paymentSheetContainer = commonState.paymentSheetContainerId
                    ? document.getElementById(commonState.paymentSheetContainerId)
                    : undefined;
                if (!paymentSheetContainer) {
                    eventReporter.sendEvent(SrciEventTypeEnumsObj.PAYMENT_SHEET_RENDER_FAIL_CONTAINER_DOESNT_EXISTS);
                    return [2 /*return*/];
                }
                isCloseButtonEnabled = commonState.isCloseButtonEnabled;
                return [4 /*yield*/, getScreenElement(newSrciScreen, isCloseButtonEnabled, isFetchProfilesEnabled)];
            case 1:
                screenElement = _a.sent();
                if (!screenElement)
                    throw new Error("Error on getting srci ui component");
                if (commonState.isDcfFlowPopUp === true) {
                    paymentSheetContainer.replaceChildren(screenElement);
                    return [2 /*return*/];
                }
                srciUiComponent = document.getElementById(srciUiComponentId);
                if (!srciUiComponent)
                    paymentSheetContainer.appendChild(screenElement);
                else
                    paymentSheetContainer.replaceChild(screenElement, srciUiComponent);
                return [2 /*return*/];
        }
    });
}); };
var getScreenElement = function (srciScreenEnum, isCloseButtonEnabled, isFetchProfilesEnabled) { return __awaiter(void 0, void 0, void 0, function () {
    var screenElement;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (function () { return __awaiter(void 0, void 0, void 0, function () {
                    var _a;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                _a = srciScreenEnum;
                                switch (_a) {
                                    case SrciScreenEnumsObj.NEW_USER_SCREEN: return [3 /*break*/, 1];
                                    case SrciScreenEnumsObj.OTP_SCREEN: return [3 /*break*/, 3];
                                    case SrciScreenEnumsObj.OTP_CHANNEL: return [3 /*break*/, 5];
                                    case SrciScreenEnumsObj.CARD_LIST_SCREEN: return [3 /*break*/, 7];
                                    case SrciScreenEnumsObj.LOGIN_SCREEN: return [3 /*break*/, 9];
                                    case SrciScreenEnumsObj.ADD_CARD_SCREEN: return [3 /*break*/, 11];
                                }
                                return [3 /*break*/, 13];
                            case 1: return [4 /*yield*/, (srciUiSdk === null || srciUiSdk === void 0 ? void 0 : srciUiSdk.getNewUserScreen(commonState, mastercardState, visaState, locale, isCloseButtonEnabled))];
                            case 2: return [2 /*return*/, _b.sent()];
                            case 3: return [4 /*yield*/, (srciUiSdk === null || srciUiSdk === void 0 ? void 0 : srciUiSdk.getOtpScreen(commonState, mastercardState, visaState, locale, isCloseButtonEnabled))];
                            case 4: return [2 /*return*/, _b.sent()];
                            case 5: return [4 /*yield*/, (srciUiSdk === null || srciUiSdk === void 0 ? void 0 : srciUiSdk.getOtpChannelScreen(commonState, mastercardState, visaState, locale, isCloseButtonEnabled))];
                            case 6: return [2 /*return*/, _b.sent()];
                            case 7: return [4 /*yield*/, (srciUiSdk === null || srciUiSdk === void 0 ? void 0 : srciUiSdk.getCardListScreen(commonState, mastercardState, visaState, locale, isCloseButtonEnabled, isFetchProfilesEnabled))];
                            case 8: return [2 /*return*/, _b.sent()];
                            case 9: return [4 /*yield*/, (srciUiSdk === null || srciUiSdk === void 0 ? void 0 : srciUiSdk.getLoginScreen(commonState, mastercardState, visaState, locale, isCloseButtonEnabled))];
                            case 10: return [2 /*return*/, _b.sent()];
                            case 11: return [4 /*yield*/, (srciUiSdk === null || srciUiSdk === void 0 ? void 0 : srciUiSdk.getAddCardScreen(commonState, mastercardState, visaState, locale, isCloseButtonEnabled))];
                            case 12: return [2 /*return*/, _b.sent()];
                            case 13: throw new Error("Wrong srci screen enum");
                        }
                    });
                }); })()];
            case 1:
                screenElement = _a.sent();
                if (screenElement) {
                    screenElement.id = srciUiComponentId;
                    screenElement.className = "".concat(srciUiComponentId, " ").concat(paymentSheetScreenClassName);
                    return [2 /*return*/, screenElement];
                }
                return [2 /*return*/, undefined];
        }
    });
}); };
var addContainerToBody = function (container) {
    ensurePaymentSheetStyles();
    var bodyElement = document.querySelector("body");
    var paymentSheetElement = document.createElement("div");
    paymentSheetElement.id = container;
    paymentSheetElement.className = paymentSheetOverlayClassName;
    bodyElement === null || bodyElement === void 0 ? void 0 : bodyElement.append(paymentSheetElement);
    lockPaymentSheetHostScroll();
};
